import { useEffect } from 'react'
import { onCLS, onINP, onLCP } from 'web-vitals'

import { useAbTest, useTrackAbTest } from '@marketplace-web/shared/ab-tests'
import { getInitialBreakpoints } from '@marketplace-web/shared/breakpoints'
import { clientSideMetrics } from '@marketplace-web/shared/metrics'
import { MS_PER_SECOND } from '@marketplace-web/shared/utils'
import { useSession } from '@marketplace-web/shared/session'

export const deviceFromBreakpoints = () => {
  const breakpoints = getInitialBreakpoints()

  if (breakpoints.phones || breakpoints.tablets) return 'mobile'
  if (breakpoints.desktops) return 'desktop'

  return 'unknown'
}

const useServerAbTest = () => {
  const abTest = useAbTest('web_homepage_server')
  const isLoggedIn = !!useSession().user
  useTrackAbTest(abTest)

  const isEnabled = abTest?.variant === 'on'

  useEffect(() => {
    onLCP(metric => {
      const device = deviceFromBreakpoints()

      clientSideMetrics
        .histogram(
          'home_largest_contentful_paint',
          { device, type: isEnabled ? 'new' : 'old', user_type: isLoggedIn ? 'logged_in' : 'anon' },
          [
            0.25, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10,
            15, 20,
          ],
        )
        .observe(metric.value / MS_PER_SECOND)
    })
  }, [isEnabled, isLoggedIn])

  useEffect(() => {
    onCLS(metric => {
      const device = deviceFromBreakpoints()

      clientSideMetrics
        .histogram(
          'home_cumulative_layout_shift',
          { device, type: isEnabled ? 'new' : 'old', user_type: isLoggedIn ? 'logged_in' : 'anon' },
          [
            0.001, 0.01, 0.05, 0.1, 0.125, 0.15, 0.175, 0.2, 0.225, 0.25, 0.3, 0.35, 0.4, 0.5, 0.75,
            1, 5,
          ],
        )
        .observe(metric.value)
    })
  }, [isEnabled, isLoggedIn])

  useEffect(() => {
    onINP(metric => {
      const device = deviceFromBreakpoints()

      clientSideMetrics
        .histogram(
          'home_interaction_to_next_paint',
          { device, type: isEnabled ? 'new' : 'old', user_type: isLoggedIn ? 'logged_in' : 'anon' },
          [0.005, 0.01, 0.025, 0.05, 0.1, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.6, 0.75, 1, 2, 5],
        )
        .observe(metric.value / MS_PER_SECOND)
    })
  }, [isEnabled, isLoggedIn])
}

export default useServerAbTest
